import * as PropertyBucket from "../../Properties/Properties";
import {getServicePromise} from "../../Components/HttpService/HttpService";

function action(type) {
    return {
        type
    }
}

function actionPayload(type, payload){
    return {
        type,
        payload
    }
}

export function getControllingEntitySubjects() {

  return (dispatch) => {
    dispatch(action(GET_CONTROLING_ENTITY_SUBJECTS_REQUESTED));
    let response = getServicePromise(
      PropertyBucket.getControllingEntitiesDictionary(),
      "GET"
    );

    response
      .then((data) => {
        dispatch(actionPayload(GET_CONTROLING_ENTITY_SUBJECTS_SUCCESS, data));
      })
      .catch((error) => {
        dispatch(actionPayload(GET_CONTROLING_ENTITY_SUBJECTS_FAIL, error));
      });
  };
}

export function createControllingEntity(values) {

  return (dispatch) => {
    dispatch(action(CREATE_CONTROLLING_ENTITY_REQUEST));
      let response = getServicePromise(PropertyBucket.getControllingEntitiesDictionary(), "POST", values);

    response
      .then((data) => {
        dispatch(actionPayload(CREATE_CONTROLLING_ENTITY_SUCCESS, data));
      })
      .catch((error) => {
        dispatch(actionPayload(CREATE_CONTROLLING_ENTITY_FAIL, error));
      });
  };
}

export function activateControllingEntity(id) {

  return (dispatch) => {
    dispatch(action(SET_CONTROLLING_ENTITY_ACTIVE_REQUEST));
    let response = getServicePromise(
      PropertyBucket.getControllingEntitiesDictionaryActivate(id),
      "PUT"
    );

    response
      .then((data) => {
        dispatch(actionPayload(SET_CONTROLLING_ENTITY_ACTIVE_SUCCESS, data));
      })
      .catch((error) => {
        dispatch(actionPayload(SET_CONTROLLING_ENTITY_ACTIVE_FAIL, error));
      });
  };
}

export function deactivateControllingEntity(id) {

  return (dispatch) => {
    dispatch(action(SET_CONTROLLING_ENTITY_DEACTIVATED_REQUEST));
    let response = getServicePromise(
      PropertyBucket.getControllingEntitiesDictionaryDeactivate(id),
      "PUT"
    );

    response
      .then((data) => {
        dispatch(actionPayload(SET_CONTROLLING_ENTITY_DEACTIVATED_SUCCESS, data));
      })
      .catch((error) => {
        dispatch(actionPayload(SET_CONTROLLING_ENTITY_DEACTIVATED_FAIL, error));
      });
  };
}

export const GET_CONTROLING_ENTITY_SUBJECTS_REQUESTED =
  "GET_CONTROLING_ENTITY_SUBJECTS_REQUESTED";
export const GET_CONTROLING_ENTITY_SUBJECTS_SUCCESS =
  "GET_CONTROLING_ENTITY_SUBJECTS_SUCCESS";
export const GET_CONTROLING_ENTITY_SUBJECTS_FAIL =
  "GET_CONTROLING_ENTITY_SUBJECTS_FAIL";

export const SET_CONTROLLING_ENTITY_ACTIVE_REQUEST =
  "SET_CONTROLLING_ENTITY_ACTIVE_REQUEST";
export const SET_CONTROLLING_ENTITY_ACTIVE_SUCCESS =
  "SET_CONTROLLING_ENTITY_ACTIVE_SUCCESS";
export const SET_CONTROLLING_ENTITY_ACTIVE_FAIL =
  "SET_CONTROLLING_ENTITY_ACTIVE_FAIL";

export const SET_CONTROLLING_ENTITY_DEACTIVATED_REQUEST =
  "SET_CONTROLLING_ENTITY_DEACTIVATED_REQUEST";
export const SET_CONTROLLING_ENTITY_DEACTIVATED_SUCCESS =
  "SET_CONTROLLING_ENTITY_DEACTIVATED_SUCCESS";
export const SET_CONTROLLING_ENTITY_DEACTIVATED_FAIL =
  "SET_CONTROLLING_ENTITY_DEACTIVATED_FAIL";

export const CREATE_CONTROLLING_ENTITY_REQUEST =
  "CREATE_CONTROLLING_ENTITY_REQUEST";
export const CREATE_CONTROLLING_ENTITY_SUCCESS =
  "CREATE_CONTROLLING_ENTITY_SUCCESS";
export const CREATE_CONTROLLING_ENTITY_FAIL =
  "CREATE_CONTROLLING_ENTITY_FAIL";